import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { checkFileSizeLimit } from 'shared/helpers/FileHelper';
import { DirectUpload } from 'activestorage';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { MAX_ATTACHMENT_COUNT } from 'dashboard/constants/attachments';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    installationLimit() {
      return resolveMaximumFileUploadSize(
        this.globalConfig.maximumFileUploadSize
      );
    },
  },

  methods: {
    maxSizeFor() {
      // Use default/installation limit for private notes
      if (this.isOnPrivateNote) {
        return this.installationLimit;
      }

      const channelType = this.inbox?.channel_type;

      if (!channelType || channelType === INBOX_TYPES.WEB) {
        return this.installationLimit;
      }

      // Always use installation limit — Evolution API handles actual channel limits
      return this.installationLimit;
    },
    alertOverLimit(maxSizeMB) {
      useAlert(
        this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
          MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE: maxSizeMB,
        })
      );
    },
    onFileUpload(file) {
      if (!file) return;

      const attachedCount = this.attachedFiles?.length || 0;
      const pendingCount = this.pendingAttachmentUploads || 0;
      if (attachedCount + pendingCount >= MAX_ATTACHMENT_COUNT) {
        useAlert(
          `Você pode enviar no máximo ${MAX_ATTACHMENT_COUNT} arquivos por vez.`
        );
        return;
      }

      this.pendingAttachmentUploads = pendingCount + 1;
      if (this.globalConfig.directUploadsEnabled) {
        this.onDirectFileUpload(file);
      } else {
        this.onIndirectFileUpload(file);
      }
    },

    releaseAttachmentUploadSlot() {
      if (this.pendingAttachmentUploads > 0) {
        this.pendingAttachmentUploads -= 1;
      }
    },

    onDirectFileUpload(file) {
      if (!file) return;

      const maxSizeMB = this.maxSizeFor();

      if (!checkFileSizeLimit(file, maxSizeMB)) {
        this.releaseAttachmentUploadSlot();
        this.alertOverLimit(maxSizeMB);
        return;
      }

      const upload = new DirectUpload(
        file.file,
        `/api/v1/accounts/${this.accountId}/conversations/${this.currentChat.id}/direct_uploads`,
        {
          directUploadWillCreateBlobWithXHR: xhr => {
            xhr.setRequestHeader(
              'api_access_token',
              this.currentUser.access_token
            );
          },
        }
      );

      upload.create((error, blob) => {
        if (error) {
          this.attachFile({ file });
          useAlert(error?.message || error);
        } else {
          this.attachFile({ file, blob });
        }
      });
    },

    onIndirectFileUpload(file) {
      if (!file) return;

      const maxSizeMB = this.maxSizeFor();

      if (!checkFileSizeLimit(file, maxSizeMB)) {
        this.releaseAttachmentUploadSlot();
        this.alertOverLimit(maxSizeMB);
        return;
      }

      this.attachFile({ file });
    },
  },
};
